import React from "react";
import Slider from "react-slick";
import "./stores-category-slider.scss";
import All from "../../../images/All-catagory.png";
import searchedProducts from "../../../images/Ellipse 3674.png";

const StoresCategorySlider = ({ activeCategory = "All", categoriesData = [], handleSubcategoryClick, goToTop, searchText, isHomePage, navigate }) => {
  const ExcitingSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 9,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 812,
        settings: {
          arrows: false,
          slidesToScroll: 3,
          slidesToShow: 3.5,
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          slidesToScroll: 3,
          slidesToShow: 3.5,
        },
      },
    ],
  };

  const onPressCategory = (category, activeCat, isHomePage) => {
    if (!isHomePage) {
      handleSubcategoryClick(activeCat)
      goToTop();
    }
    else {
      const encodedValue = encodeURIComponent(category?.title);
      navigate(`/category?name=${encodedValue}`);
    }
  }

  const repeatItems = [
    ...(searchText
      ? [
        <div
          key="searched"
          className={`stores-category-slider-items-kl ${activeCategory === "Searched Products" ? "slick-current" : ""}`}
        >
          <div
            className="stores-category-items-img-kl"
            onClick={() => {
              onPressCategory(null, "Searched Products", false)
            }}
          >
            <img src={searchedProducts} alt="Searched" />
          </div>
          <div className="stores-category-name-kl">Searched Products</div>
        </div>,
      ]
      : []),
    ...(!isHomePage
      ?
      [<div
        key="all"
        className={`stores-category-slider-items-kl ${activeCategory === "All" ? "slick-current" : ""}`}
      >
        <div
          className="stores-category-items-img-kl"
          onClick={() => {
            onPressCategory(null, "All", false)
          }
          }
        >
          <img src={All} alt="All" />
        </div>
        <div className="stores-category-name-kl">All</div>
      </div>,
      ]
      : []),
    ...categoriesData.map((brand, index) => (
      <div
        key={index}
        className={`stores-category-slider-items-kl ${activeCategory === brand?.title ? "slick-current" : ""}`}
      >
        <div
          className="stores-category-items-img-kl"
          onClick={() => {
            onPressCategory(brand, brand?.title, isHomePage)
          }}
        >
          <img
            src={
              brand?.imgUrl ??
              "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/0gm5dIgbx.png"
            }
            alt={brand?.title ?? "Item"}
          />
        </div>
        <div className="stores-category-name-kl">{brand?.title ?? ""}</div>
      </div>
    )),
  ];

  return (
    <Slider {...ExcitingSettings} className="stores-category-slider-kl">
      {repeatItems}
    </Slider>
  );
};

export default StoresCategorySlider;
